import { render, staticRenderFns } from "./InsertFormattedText.vue?vue&type=template&id=cfbafd66"
import script from "./InsertFormattedText.vue?vue&type=script&lang=js"
export * from "./InsertFormattedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports